import { Stack, Typography } from '@mui/material';
import { FileUpload, RadioButtons } from 'Components';
import { yesNoOptions } from 'Constants';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';

export const MedicalFiles = () => {
  const { index, fieldId } = useContext(IndexContext);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}`;

  const [areThereMedicalDocuments] = useWatch({
    name: [`${baseName}.areThereMedicalDocuments`],
  });

  return (
    <Stack gap='20px'>
      <Stack gap='10px'>
        <Typography
          fontSize={isDesktop ? '18px !important' : '16px !important'}
          sx={{ fontWeight: 'bold' }}
        >
          {dictionary.fifthSectionTitle}
        </Typography>
        <Typography>{dictionary.fifthSectionTitleDesc}</Typography>
      </Stack>
      <RadioButtons
        id={dictionary.fifthSectionMedicalDoc}
        name={`${baseName}.areThereMedicalDocuments` as const}
        options={yesNoOptions}
      />
      {areThereMedicalDocuments && (
        <FileUpload
          caseDetailsId={fieldId}
          fileLabel={dictionary.fifthSectionMedicalFile}
          fileCategoryId={FileCategories.MedicalDocument}
          ariaLabel={dictionary.fifthSectionMedicalFile}
          dataRequired
        />
      )}
    </Stack>
  );
};
